import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "echarts/dist/echarts";
import { Provider } from "react-redux";
import store from "./store";
import { initSidebarFavorites } from "./components/sidebar/sidebarData.init";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

const render = () =>
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>,
  );

// Render first. This used to be `await initSidebarFavorites()` before the very
// first render, which put an authenticated API call (and therefore a token
// refresh) in front of React mounting at all - a slow or hanging auth server
// left #root empty with no error and nothing an error boundary could catch.
// The favourites are sidebar decoration, so they load in the background and
// reconcile into the tree when they arrive.
render();
initSidebarFavorites().finally(render);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
